export default __webpack_public_path__ + "static/media/imageFour.122c6d61.png";